

import React from 'react'
import styles from "./AllCategory.module.css"
import Tabs from './Tabs'

export default function AllCategory() {
  return (
    <div className={styles.containerCategory}>
        <div className={styles.rowCategory}>
           <Tabs/>
        </div>
        </div>
  )
}
